import { getProduct, getAllPolicies } from '../lib/requests.es6';
import { isComplexPartner, getPartnerGuid } from '../lib/access.es6';
import { PARTNERS_GUID_ENUM } from '../routes/PartnersEnum';

const productSchemeCache = {};
const pendingRequests = {};

export function fetchProductScheme(productGuid) {
  if (productSchemeCache[productGuid]) {
    return Promise.resolve(productSchemeCache[productGuid]);
  }

  if (!pendingRequests[productGuid]) {
    pendingRequests[productGuid] = getProduct(productGuid)
      .then(response => {
        const scheme = response && response.data && response.data.scheme;
        if (scheme) {
          productSchemeCache[productGuid] = scheme;
        }
        delete pendingRequests[productGuid];
        return scheme;
      })
      .catch(function () {
        delete pendingRequests[productGuid];
        return null;
      });
  }

  return pendingRequests[productGuid];
}

// Resolves whether a policy should use the complex view: the product's own
// scheme wins when set (e.g. MMI_Ghana's emplife_plus), otherwise falls
// back to the partner-level policy_scheme.
export function resolveIsComplexProduct(productGuid) {
  const fallbackIsComplex = isComplexPartner();

  if (!productGuid) {
    return Promise.resolve(fallbackIsComplex);
  }

  return fetchProductScheme(productGuid).then(scheme => {
    return scheme ? scheme.toLowerCase() === 'complex' : fallbackIsComplex;
  });
}

// A customer search hit carries no product info, so scheme can't be read
// off it directly. Only for mixed-scheme partners (currently MMI_Ghana) do
// we look at the customer's actual policies to decide whether "View
// Customer" should land on the complex screen; every other partner keeps
// its single, partner-wide behavior with no extra request.
export function resolveCustomerStatusPath(customerGuid) {
  const basePath = 'admin/customer_status/' + customerGuid;

  if (getPartnerGuid() !== PARTNERS_GUID_ENUM.MMI_GHANA) {
    return Promise.resolve(basePath);
  }

  return getAllPolicies({ guid: customerGuid })
    .then(response => {
      const policies = (response && response.data) || [];
      return Promise.all(policies.map(policy => resolveIsComplexProduct(policy.product_guid)));
    })
    .then(results => {
      return results.some(Boolean) ? basePath + '?view=complex' : basePath;
    })
    .catch(() => basePath);
}
